import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { AppTokenService } from "../../app-token.service";
import { HttpHandlerService } from "../../http-handler.service";

@Injectable()

export class CreditControlService {
    _httpHandler: HttpHandlerService;
    _apiUrl = environment.apiUrl;
    _getResourceEndPoint = 'creditcontrol';

    constructor(private httpHandler: HttpHandlerService,
        private appTokenService: AppTokenService) {
        this._httpHandler = httpHandler;
    }

    public GetAllList(params?: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/list?sc=${params.scid}`
        if (params?.refresh) {
            full_api_url = full_api_url + `refresh=${new Date().getTime()}`;
        }
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetById(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${id}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public GetByTypeCustomerOrSCId(data?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/creditlimit`
        const request_option = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public CheckCreditLimit(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/details`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public Add(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public Update(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public DeleteById(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${id}`;
        const request_option = this._httpHandler.prepareRequest(
            'DELETE',
            full_api_url,
            {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }
}
